import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ProblemsComponent } from './problems.component';

@NgModule({
    entryComponents: [
        ProblemsComponent
    ],
    declarations: [
        ProblemsComponent
    ],
    imports: [
        TranslateModule,
        FuseSharedModule,
        MatAutocompleteModule,
        MatProgressBarModule,
        MatSelectModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule
    ],
    exports: [
        ProblemsComponent
    ]
})
export class ProblemsModule {}
